import { RootState } from 'store/rootReducer';

export const getNewNotifications = (store: RootState) =>
  store.notifications.counters;

export const getIsFirstLoading = (store: RootState) =>
  store.notifications.isFirstLoading;
